import type { Theme } from '@mui/material/styles';

export default function SvgIcon(_: Theme) {
  return {
    MuiSvgIcon: {
      styleOverrides: {
        fontSizeSmall: {
          width: 16,
          height: 16,
          fontSize: 'inherit',
        },
        fontSizeMedium: {
          width: 24,
          height: 24,
          fontSize: 'inherit',
        },
        fontSizeLarge: {
          width: 32,
          height: 32,
          fontSize: 'inherit',
        },
      },
    },
  };
}
